// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg viewBox=%270 0 1440 320%27 xmlns=%27http://www.w3.org/2000/svg%27><path fill=%27%23ffffff10%27 fill-opacity=%271%27 d=%27M0,224L80,202.7C160,181,320,139,480,144C640,149,800,203,960,202.7C1120,203,1280,149,1360,122.7L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z%27></path></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* *,
*::before,
*::after {
  box-sizing: border-box;
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
}

.login-form {
  width: 100%;
  max-width: 400px;
  background: #fff;
  padding: 20px 20px;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.8s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-avatar {
  background-color: #1a0303;
  width: 60px;
  height: 60px;
  margin-bottom: 40px;
}

.login-title {
  margin: 20px 0;
  font-size: 32px;
  font-weight: 700;
  color: var(--gray-800);
  text-align: center;
}

.login-button {
  padding: 12px;
  margin-top: 10px;
  background: linear-gradient(45deg, #2196f3, #21cbf3);
  color: white;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  text-transform: none;
  transition: background 0.3s ease;
}

.login-button:hover {
  background: linear-gradient(45deg, #1976d2, #1e88e5);
}

.forgot-password,
.register-link {
  margin-top: 15px;
  cursor: pointer;
  color: #1976d2;
  text-align: center;
  transition: color 0.3s ease;
}

.forgot-password:hover,
.register-link:hover {
  color: #155a9c;
}

.register-highlight {
  font-weight: bold;
}

@media (max-width: 768px) {
  .login-form {
    padding: 30px 20px;
  }

  .login-title {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .login-avatar {
    width: 50px;
    height: 50px;
  }

  .login-title {
    font-size: 20px;
  }

  .login-button {
    font-size: 14px;
    padding: 10px;
  }
} */
/* ///////////////////////Rishabh version start */

/* GLOBAL SCROLL PREVENTION */
.login-wrapper {
  display: flex;
  min-height: calc(100vh - 120px);
  width: 100%;
  padding: 30px 0;
  box-sizing: border-box;
  align-items: stretch;
  margin-top: 40px;
}

/* === LEFT PANEL WITH GRADIENT AND WAVES === */
.login-left {
  flex: 1 1;
  background: linear-gradient(to bottom right, #152D85, #1E40AF);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 40px;
  position: relative;
  overflow: hidden;
  clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
  animation: fadeInLeft 1s ease-out;
  opacity: 0;
  animation-fill-mode: forwards;
}



/* Wave SVG overlay */
.login-left::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 180px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat bottom;
  background-size: cover;
  pointer-events: none;
}

/* Animation */
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-40px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* === LEFT CONTENT === */
.login-logo {
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 40px;
}

.login-heading {
  font-size: 36px;
  font-weight: bold;
  line-height: 1.3;
  margin-bottom: 16px;
}

.login-subtext {
  font-size: 16px;
  margin-top: 8px;
  max-width: 400px;
}

/* Footer text at bottom */
.login-footer-text {
  position: absolute;
  bottom: 20px;
  left: 40px;
  font-size: 14px;
  opacity: 0.9;
}

/* === RIGHT PANEL === */
.login-right {
  flex: 1 1;
  background: var(--gray-50);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.login-subheading {
  text-align: center;
  font-size: 0.95rem;
  color: var(--gray-500);
  margin-bottom: 20px;
  margin-top: -10px;
}

/* === LOGIN CARD === */
.login-card {
  background: white;
  border-radius: 16px;
  padding: 32px;
  width: 100%;
  max-width: 400px;

  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.04),
    12px 12px 0 rgba(0, 0, 0, 0.07);  /* Bigger offset shadow */
}


.login-title {
  text-align: center;
  margin-bottom: 20px;
  color: var(--gray-800);
  font-size: 1.3rem;
  font-weight: 600;
}

/* === OPTIONS === */
.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 12px 0 16px;
  font-size: 0.9rem;
}

.forgot-link {
  color: #5C85FF;
  cursor: pointer;
}

.forgot-link:hover {
  text-decoration: underline;
}

/* === LOGIN BUTTON === */
.login-button {
  background: linear-gradient(135deg, #1E40AF, #1A379A);
  color: white !important;
  font-weight: 600;
  padding: 12px 0;
  border-radius: 10px;
  text-align: center;
  border: none;
  margin-top: 8px;
  font-size: 1rem;
  cursor: pointer;
}

/* === RESPONSIVE === */
@media (max-width: 768px) {
  .login-wrapper {
    flex-direction: column;
    min-height: auto;
    padding: 0;
  }

  /* Smaller left panel on mobile */
  .login-left {
    clip-path: none;
    padding: 24px 16px;
    height: auto;
    min-height: 200px;
    text-align: center;
    justify-content: flex-start;
  }

  .login-logo {
    font-size: 0.9rem;
    margin-bottom: 24px;
  }

  .login-heading {
    font-size: 24px;
    margin-bottom: 12px;
  }

  .login-subtext {
    font-size: 14px;
    margin-top: 6px;
    max-width: 100%;
  }

  .login-footer-text {
    position: static;
    margin-top: 20px;
    text-align: center;
    font-size: 13px;
  }

  .login-right {
    padding: 16px;
  }

  .login-card {
    padding: 24px;
    max-width: 100%;
    box-shadow:
      0 10px 30px rgba(0, 0, 0, 0.2),
      8px 8px 0 rgba(0, 0, 0, 0.05);
  }

  .login-title {
    font-size: 1.1rem;
  }

  .login-subheading {
    font-size: 0.85rem;
    margin-top: -8px;
  }

  .login-button {
    padding: 10px 0;
    font-size: 0.95rem;
  }
  .login-logo{
    display: none;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkHG;AACH,iDAAiD;;AAEjD,6BAA6B;AAC7B;EACE,aAAa;EACb,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,SAAO;EACP,8DAA8D;EAC9D,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;EAClD,iCAAiC;EACjC,UAAU;EACV,6BAA6B;AAC/B;;;;AAIA,qBAAqB;AACrB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,oEAA+X;EAC/X,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;;EAEhB;;mCAEiC,GAAG,yBAAyB;AAC/D;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,qDAAqD;EACrD,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;EACZ;;EAEA,iCAAiC;EACjC;IACE,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;IACf;;mCAE+B;EACjC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* *,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  padding: 20px;\n}\n\n.login-form {\n  width: 100%;\n  max-width: 400px;\n  background: #fff;\n  padding: 20px 20px;\n  border-radius: 12px;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n  animation: fadeIn 0.8s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.login-avatar {\n  background-color: #1a0303;\n  width: 60px;\n  height: 60px;\n  margin-bottom: 40px;\n}\n\n.login-title {\n  margin: 20px 0;\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--gray-800);\n  text-align: center;\n}\n\n.login-button {\n  padding: 12px;\n  margin-top: 10px;\n  background: linear-gradient(45deg, #2196f3, #21cbf3);\n  color: white;\n  font-size: 16px;\n  border: none;\n  border-radius: 8px;\n  text-transform: none;\n  transition: background 0.3s ease;\n}\n\n.login-button:hover {\n  background: linear-gradient(45deg, #1976d2, #1e88e5);\n}\n\n.forgot-password,\n.register-link {\n  margin-top: 15px;\n  cursor: pointer;\n  color: #1976d2;\n  text-align: center;\n  transition: color 0.3s ease;\n}\n\n.forgot-password:hover,\n.register-link:hover {\n  color: #155a9c;\n}\n\n.register-highlight {\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .login-form {\n    padding: 30px 20px;\n  }\n\n  .login-title {\n    font-size: 24px;\n  }\n}\n\n@media (max-width: 480px) {\n  .login-avatar {\n    width: 50px;\n    height: 50px;\n  }\n\n  .login-title {\n    font-size: 20px;\n  }\n\n  .login-button {\n    font-size: 14px;\n    padding: 10px;\n  }\n} */\n/* ///////////////////////Rishabh version start */\n\n/* GLOBAL SCROLL PREVENTION */\n.login-wrapper {\n  display: flex;\n  min-height: calc(100vh - 120px);\n  width: 100%;\n  padding: 30px 0;\n  box-sizing: border-box;\n  align-items: stretch;\n  margin-top: 40px;\n}\n\n/* === LEFT PANEL WITH GRADIENT AND WAVES === */\n.login-left {\n  flex: 1;\n  background: linear-gradient(to bottom right, #152D85, #1E40AF);\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 40px;\n  position: relative;\n  overflow: hidden;\n  clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);\n  animation: fadeInLeft 1s ease-out;\n  opacity: 0;\n  animation-fill-mode: forwards;\n}\n\n\n\n/* Wave SVG overlay */\n.login-left::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 180px;\n  background: url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 1440 320' xmlns='http://www.w3.org/2000/svg'><path fill='%23ffffff10' fill-opacity='1' d='M0,224L80,202.7C160,181,320,139,480,144C640,149,800,203,960,202.7C1120,203,1280,149,1360,122.7L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z'></path></svg>\") no-repeat bottom;\n  background-size: cover;\n  pointer-events: none;\n}\n\n/* Animation */\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-40px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* === LEFT CONTENT === */\n.login-logo {\n  font-weight: bold;\n  font-size: 1rem;\n  margin-bottom: 40px;\n}\n\n.login-heading {\n  font-size: 36px;\n  font-weight: bold;\n  line-height: 1.3;\n  margin-bottom: 16px;\n}\n\n.login-subtext {\n  font-size: 16px;\n  margin-top: 8px;\n  max-width: 400px;\n}\n\n/* Footer text at bottom */\n.login-footer-text {\n  position: absolute;\n  bottom: 20px;\n  left: 40px;\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n/* === RIGHT PANEL === */\n.login-right {\n  flex: 1;\n  background: var(--gray-50);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n}\n.login-subheading {\n  text-align: center;\n  font-size: 0.95rem;\n  color: var(--gray-500);\n  margin-bottom: 20px;\n  margin-top: -10px;\n}\n\n/* === LOGIN CARD === */\n.login-card {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  width: 100%;\n  max-width: 400px;\n\n  box-shadow:\n    0 20px 60px rgba(0, 0, 0, 0.12), 0 4px 8px rgba(0, 0, 0, 0.04),\n    12px 12px 0 rgba(0, 0, 0, 0.07);  /* Bigger offset shadow */\n}\n\n\n.login-title {\n  text-align: center;\n  margin-bottom: 20px;\n  color: var(--gray-800);\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n/* === OPTIONS === */\n.login-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 12px 0 16px;\n  font-size: 0.9rem;\n}\n\n.forgot-link {\n  color: #5C85FF;\n  cursor: pointer;\n}\n\n.forgot-link:hover {\n  text-decoration: underline;\n}\n\n/* === LOGIN BUTTON === */\n.login-button {\n  background: linear-gradient(135deg, #1E40AF, #1A379A);\n  color: white !important;\n  font-weight: 600;\n  padding: 12px 0;\n  border-radius: 10px;\n  text-align: center;\n  border: none;\n  margin-top: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n/* === RESPONSIVE === */\n@media (max-width: 768px) {\n  .login-wrapper {\n    flex-direction: column;\n    min-height: auto;\n    padding: 0;\n  }\n\n  /* Smaller left panel on mobile */\n  .login-left {\n    clip-path: none;\n    padding: 24px 16px;\n    height: auto;\n    min-height: 200px;\n    text-align: center;\n    justify-content: flex-start;\n  }\n\n  .login-logo {\n    font-size: 0.9rem;\n    margin-bottom: 24px;\n  }\n\n  .login-heading {\n    font-size: 24px;\n    margin-bottom: 12px;\n  }\n\n  .login-subtext {\n    font-size: 14px;\n    margin-top: 6px;\n    max-width: 100%;\n  }\n\n  .login-footer-text {\n    position: static;\n    margin-top: 20px;\n    text-align: center;\n    font-size: 13px;\n  }\n\n  .login-right {\n    padding: 16px;\n  }\n\n  .login-card {\n    padding: 24px;\n    max-width: 100%;\n    box-shadow:\n      0 10px 30px rgba(0, 0, 0, 0.2),\n      8px 8px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .login-title {\n    font-size: 1.1rem;\n  }\n\n  .login-subheading {\n    font-size: 0.85rem;\n    margin-top: -8px;\n  }\n\n  .login-button {\n    padding: 10px 0;\n    font-size: 0.95rem;\n  }\n  .login-logo{\n    display: none;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
